import { render, staticRenderFns } from "./ShipmentIssues.vue?vue&type=template&id=9a8ed94a&scoped=true"
import script from "./ShipmentIssues.vue?vue&type=script&lang=js"
export * from "./ShipmentIssues.vue?vue&type=script&lang=js"
import style0 from "./ShipmentIssues.vue?vue&type=style&index=0&id=9a8ed94a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a8ed94a",
  null
  
)

export default component.exports